import { render } from "./_Modal-image.vue?vue&type=template&id=41c7f024&scoped=true"
import script from "./_Modal-image.vue?vue&type=script&lang=js"
export * from "./_Modal-image.vue?vue&type=script&lang=js"

import "./_Modal-image.vue?vue&type=style&index=0&id=41c7f024&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-41c7f024"

export default script